import * as React from 'react'
import { memo } from 'react'
const SvgChevronDown = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 5.66 5">
    <path d="M3.283.849A4.07 4.07 0 0 1 5.66 0a12.2 12.2 0 0 0-2.83 5A11.6 11.6 0 0 0 0 0a4.23 4.23 0 0 1 2.377.943Z" />
  </svg>
)
const Memo = memo(SvgChevronDown)
export default Memo
